var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01CalendarioSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.14 19.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.24,163.36a3.57,3.57,0,0,0-2.05-1,10.1,10.1,0,0,0-1.35,0v-.67a.7.7,0,0,0-.5-.82h-.26a.72.72,0,0,0-.5.84,2,2,0,0,1,0,.35v.29h-7.67v-.68a.91.91,0,0,0-.06-.4.66.66,0,0,0-.61-.41h-.09a.73.73,0,0,0-.51.82,3.73,3.73,0,0,1,0,.47s0,.19,0,.22h-.45c-.23,0-.46,0-.68,0a3.52,3.52,0,0,0-2.44,1.24,4.22,4.22,0,0,0-.88,3v6c0,1.17,0,2.33,0,3.49a3.81,3.81,0,0,0,1,2.75,3.58,3.58,0,0,0,1.56.94,3.35,3.35,0,0,0,1,.15h12a3.59,3.59,0,0,0,3.57-3.58c0-3.52,0-7.1,0-10.46A3.67,3.67,0,0,0,419.24,163.36Zm-.19,12.92a2.35,2.35,0,0,1-2.39,2.4H404.82a2.36,2.36,0,0,1-2.38-2.39V168H419v.18c0,.05,0,.1,0,.15v7.91Zm0-9.63,0,.11H402.49l0-.11a2.75,2.75,0,0,1,.63-2.36,2.79,2.79,0,0,1,2.43-.7h.12v1.5a.76.76,0,0,0,.19.53.64.64,0,0,0,.44.17.65.65,0,0,0,.63-.7v-1.34s0,0,0-.07l0-.08.1,0h7.53v1.6a.63.63,0,0,0,1.26,0v-1.56H416a2.53,2.53,0,0,1,3.08,3.05Z",
    transform: "translate(-401.17 -160.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M407,175h-1.51a.64.64,0,0,0-.62.63.63.63,0,0,0,.61.63q.78,0,1.53,0a.63.63,0,0,0,0-1.26Z",
    transform: "translate(-401.17 -160.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415.93,175H414.5a.63.63,0,1,0,0,1.26h1.43a.63.63,0,1,0,0-1.26Z",
    transform: "translate(-401.17 -160.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M414.48,171.77H416a.64.64,0,0,0,.64-.63.63.63,0,0,0-.64-.63h-1.47a.62.62,0,0,0-.64.62A.64.64,0,0,0,414.48,171.77Z",
    transform: "translate(-401.17 -160.81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M405.55,171.77H407a.64.64,0,0,0,.63-.63.63.63,0,0,0-.64-.63h-1.47a.63.63,0,0,0-.64.62.66.66,0,0,0,.17.44A.75.75,0,0,0,405.55,171.77Z",
    transform: "translate(-401.17 -160.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410,171.77h1.49a.63.63,0,0,0,.62-.64.61.61,0,0,0-.62-.62H410a.63.63,0,0,0-.64.63A.64.64,0,0,0,410,171.77Z",
    transform: "translate(-401.17 -160.81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411.48,175H410a.63.63,0,1,0,0,1.26c.46,0,.95,0,1.49,0a.63.63,0,0,0,0-1.26Z",
    transform: "translate(-401.17 -160.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01CalendarioSelect);
export default __webpack_public_path__ + "static/media/01_Calendario_Select.69e2e5665f67a2e0855d9d5502b951f8.svg";
export { ForwardRef as ReactComponent };